<template>
  <div>
    <img
      src="@/assets/img/logo.png"
      alt="CDS Hotels"
      style="height: 1px; width: 1px"
    />
    <b-modal
      id="responseQuote"
      :centered="true"
      hide-footer
      no-close-on-backdrop
      hide-backdrop
    >
      <template v-slot:modal-header class="border-0" border-0>
        <div class="icon-box success" v-show="success">
          <img class="logo" src="@/assets/img/logo.png" alt="CDS Hotels" />
        </div>
        <div class="icon-box failure" v-show="!success">
          <img class="logo" src="@/assets/img/logo.png" alt="CDS Hotels" />
        </div>
      </template>

      <div class="d-block text-center">
        <p>
          {{ success ? $t('form.successMessage') : $t('form.errorMessage') }}
        </p>
      </div>
    </b-modal>
    <form-wizard
      ref="wizard"
      color="#7ac1e9"
      v-bind:title="title"
      v-bind:subtitle="subtitle"
      v-if="!completed && !errorFound"
    >
      <tab-content
        :title="$t('titleStep1')"
        :before-change="validateFirstStep"
        icon="ti-user"
      >
        <step-one
          ref="step1"
          :formConfiguration="formConfiguration"
          :model="model"
          :value="offerID"
          :maxValueAdults="maxValueAdults"
          :loading="loading"
          @disableNextButtonForTimeSlots="onDisableNextButtonForTimeSlots"
        ></step-one>
      </tab-content>
      <tab-content
        :title="$t('titleStep2')"
        :before-change="validateSecondStep"
        icon="ti-credit-card"
      >
        <step-two
          ref="step2"
          :formConfiguration="formConfiguration"
          :model="model"
          :loading="loading"
          @disableNextButton="onDisabledNextButton"
        ></step-two>
      </tab-content>
      <template slot="footer" slot-scope="props">
        <b-row>
          <b-col class="col-xs-6">
            <div class="wizard-footer-left">
              <wizard-button
                :disabled="props.activeTabIndex <= 0 || loading"
                @click.native="props.prevTab()"
                :style="props.fillButtonStyle"
                >{{ $t('previous') }}</wizard-button
              >
            </div>
          </b-col>
          <b-col class="col-xs-6">
            <div class="wizard-footer-right">
              <div
                class="spinner-grow text-primary"
                role="status"
                v-show="loading"
              >
                <span class="sr-only"></span>
              </div>
              <wizard-button
                @click.native="props.nextTab()"
                class="wizard-footer-right col-xs-2"
                :style="props.fillButtonStyle"
                :disabled="
                  loading ||
                  disabledNextButtonForTimeSlots ||
                  (disabledNextButton && props.isLastStep)
                "
              >
                <span class="sr-only"></span>
                {{ props.isLastStep ? $t('send') : $t('next') }}
                <!-- {{props.isSendFormStep? $t('send') : $t('next')}} -->
              </wizard-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </form-wizard>

    <div v-if="errorFound">
      <b-container class="my-5 py-5">
        <b-alert show variant="danger" class="text-center" v-if="!success">
          <div>
            <svg
              id="failureAnimation"
              class="animated"
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 70 70"
            >
              <circle
                id="failureAnimationCircle"
                cx="35"
                cy="35"
                r="24"
                stroke="#f82f66"
                stroke-width="2"
                stroke-linecap="round"
                fill="transparent"
              />
              <polyline
                class="failureAnimationCheckLine"
                stroke="#f82f66"
                stroke-width="2"
                points="25,25 45,45"
                fill="transparent"
              />
              <polyline
                class="failureAnimationCheckLine"
                stroke="#f82f66"
                stroke-width="2"
                points="45,25 25,45"
                fill="transparent"
              />
            </svg>
          </div>
          {{ errorMessage }}
        </b-alert>
        <b-alert show variant="success" class="text-center" v-else>
          <div>
            <svg
              id="successAnimation"
              class="animated"
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 70 70"
            >
              <circle
                id="successAnimationCircle"
                cx="35"
                cy="35"
                r="24"
                stroke="#005596"
                stroke-width="2"
                stroke-linecap="round"
                fill="transparent"
              />
              <polyline
                id="successAnimationCheck"
                stroke="#005596"
                stroke-width="2"
                points="23 34 34 43 47 27"
                fill="transparent"
              />
            </svg>
          </div>
          {{ $t('form.successMessage') }}
        </b-alert>
      </b-container>
    </div>
  </div>
</template>

<script>
import { IT as LANGUAGE_IT, EN as LANGUAGE_EN } from '@/models/languages';
import { OfferRequestService, ContactService } from '@/common/ApiService';
import { LocalStorage } from '@/common/LocalStorage';
import StepOne from './RequestInfoOfferStepOne';
import StepTwo from './RequestInfoOfferStepTwo';

export default {
  name: 'RequestInfoOffer',
  // component code
  components: {
    StepOne,
    StepTwo,
  },
  data: () => ({
    maxValueAdults: 8,    
    disabledNextButtonForTimeSlots: true,
    disabledNextButton: true,
    errorFound: false,
    langs: ['en', 'it'],
    mainProps: { width: 95, height: 95, class: 'm1' },
    langID: null,
    propertyCODE: null,
    dataLoaded: false,
    success: null,
    completed: false,
    subtitle: '',
    title: null,
    loading: false,
    // isActive: false,
    // isRequired: false,
    model: {
      contactID: null,
      firstName: null,
      surname: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      selectedChildren: null,
      adult: 0,
      children: 0,
      startDate: null,
      // endDate: null,
      comment: null,
      offerID: null,
      languageID: null,
      rooms: [{ adult: 2, children: 0, childrenAges: [] }],
      privacy: null,
      reservationID: null,
      progress: null,
      channelID: null,
      checkIn: null,
      checkOut: null,
      propertyCODE: null,
      rates: [],
      rateID: null,
      dateTimeValid: null,
      beforeStartBookingOptionHours: null,
      beforeStartBookingOptionMinutes: null,      
    },
    formConfiguration: {
      formID: null,
      langID: 'it',
      properties: [
        {
          propertyID: null,
          propertyCODE: null,
        },
      ],
      startDate: '',
      endDate: '',
      maxAdults: 2,      
      maxChildren: 2,
    },
  }),
  methods: {    
    parseDate(date) {
      if (undefined === date || null === date) {
        return null;
      }
      try {
        const d = date.split(/\D+/);
        d[0] *= 1;
        d[1] -= 1;
        d[2] *= 1;

        const D = new Date(d[0], d[1], d[2]);
        if (
          D.getFullYear() === d[0] &&
          D.getMonth() === d[1] &&
          D.getDate() === d[2]
        ) {
          return D;
        } else return null;
      } catch (error) {
        return null;
      }
    },
    async populateStep() {    
      
      if (this.$route.query) {
        const now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);
        now.setMilliseconds(0);        

        

        if (
          this.$route.params.offerID &&
          parseInt(this.$route.params.offerID)
        ) {
          this.offerID = parseInt(this.$route.params.offerID);
        } else {
          this.errorFound = true;
          this.errorMessage = this.$t('errorMessage.offerNotFound');
          return;
        }
        
        if (
          (this.$route.query || {}).reservationID &&
          (this.$route.query || {}).contactID
        ) {
          let reservationID = parseInt(this.$route.query.reservationID);
          let contactID = parseInt(this.$route.query.contactID);
          let params = { reservationID, contactID };
          let response = await OfferRequestService.getReservationInfoAsync(
            params
          );
          
          if (response.data) {
            if (
              (this.$route.query || {}).propertyCODE &&
              (this.$route.query || {}).propertyCODE ===
                response.data.property.propertyCODE
            ) {
              this.formConfiguration.startDate = response.data.checkIn;
              this.formConfiguration.endDate = response.data.checkOut;
              let maxAdults = response.data.numberOfAdults;
              let maxChildren = response.data.numberOfChildren;
              this.model.rooms[0] = {
                adult: 2,
                children: maxChildren,
                childrenAges: [],
              };
              this.maxValueAdults = maxAdults;
            }
          }
        }
        const startDate = this.parseDate(this.$route.query.startDate);
        this.langID = (this.$route.query || {}).lang || 'it';

        this.$i18n.locale = this.langID.toLowerCase()
               
        this.model.languageID =
          this.langID === 'it' ? LANGUAGE_IT : LANGUAGE_EN;
        if (
          this.$route.query.channelID &&
          parseInt(this.$route.query.channelID)
        ) {
          this.model.channelID = parseInt(this.$route.query.channelID);
        } else {
          this.errorFound = true;
          this.errorMessage = this.$t('errorMessage.channelNotFound');
          return;
        }
        if (this.$route.query.propertyCODE) {
          this.propertyCODE = this.$route.query.propertyCODE;
        } else {
          this.errorFound = true;
          this.errorMessage = this.$t('errorMessage.propertyNotFound');
          return;
        }

        if (this.$route.query.propertyCODE) {
          this.model.propertyCODE = this.$route.query.propertyCODE;
        }

        this.model.contactID = this.$route.query.contactID
          ? this.$route.query.contactID
          : 0;

        if (
          this.$route.params.offerID &&
          parseInt(this.$route.params.offerID)
        ) {
          this.offerID = parseInt(this.$route.params.offerID);
          var rates = await OfferRequestService.getRates(this.offerID);
          rates.data.forEach((rate) => {
            this.model.rates.push({
              value: rate.rateID,
              text: `${rate.rateName} (${rate.pricePerUnit}€)`,
            });
          });
          if (this.model.rates.length > 0) {
            this.model.rateID = this.model.rates[0].value;
          }
          this.model.offerID = this.offerID;
        }
        
        if (this.model.contactID) {
          const contactResponse = await ContactService.getContactAsync(this.model.contactID);          
          this.model.firstName = contactResponse.data.firstName;          
          this.model.surname = contactResponse.data.lastName;
          this.model.email = contactResponse.data.emailAddress;
          this.model.phoneNumber = contactResponse.data.phoneNumber;
        }
      }
    },

    validateFirstStep() {      
      return this.$refs.step1
        .validate()
        .then(() => {
          this.toggleLoading(true);
        })
        .then(() => {
          window.scrollTo(0, 0);
          return true;
        })
        .catch((e) => {
          if (!e.invalid) {
            console.log(e);
          }
        })
        .finally(() => this.toggleLoading(false));
    },
    validateSecondStep() {
      return this.$refs.step2
        .validate()
        .then(() => {
          this.toggleLoading(true);
          let model = JSON.parse(JSON.stringify(this.model));
          model.children = [];
          model.selectedChildren = 0;
          if (model.rooms && model.rooms.length > 0) {
            model.rooms.forEach((room) => {
              if (parseInt(room.adult)) {
                model.adult += parseInt(room.adult);
              }
              model.selectedChildren += room.children;
              if (room.childrenAges && room.childrenAges.length > 0) {
                room.childrenAges.forEach((childrenAge) => {
                  if (parseInt(childrenAge))
                    model.children.push(parseInt(childrenAge));
                });
              }
            });
          }
          this.updateSessionStorage(model);
          return OfferRequestService.create(model);
        })
        .then(() => {
          this.completed = true;
          this.success = true;
          this.$bvModal.show('responseQuote');
          return true;
        })
        .catch((e) => {
          if (e && e.invalid) {
            // form is not valid, do nothing
          } else {
            // this.handleError(e);
            if (
              e &&
              e.response &&
              e.response.data &&
              e.response.data.errorCode &&
              e.response.data.errorCode === 1400
            ) {
              this.model.validCode = false;
              this.$refs.step2.validate();
            } else {
              this.completed = true;
              this.$bvModal.show('responseQuote');
              this.success = false;
            }
          }
        })
        .finally(() => this.toggleLoading(false));
    },
    updateSessionStorage(model) {
      let modelToStore = this.getReservationFromSessionStorage() || {};
      Object.assign(modelToStore, {
        checkIn: model.checkIn,
        checkOut: model.checkOut,
        email: model.email,
        firstName: model.firstName,
        lastName: model.lastName,
        contactID: model.contactID,
        reservationID: model.reservationID,
      });
      this.setReservationToSessionStorage(modelToStore);
    },
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    toggleLoading(value) {
      this.loading = value;
    },
    resetForm() {
      this.model.CODE = null;
      this.model.startDate = null;
      // this.model.endDate = null;
      this.model.rooms = [{ adult: 2, children: 0, childrenAges: [] }];
      this.model.contactID = null;
      this.model.firstName = null;
      this.model.lastName = null;
      this.model.email = null;
      this.model.phoneNumber = null;
      this.model.comment = null;
      this.model.privacy = null;
      this.model.languageID = null;
      this.model.rateID = null;
      this.model.dateTimeValid = null;
      this.model.beforeStartBookingOptionHours = null;
      this.model.beforeStartBookingOptionMinutes = null;
      // this.model.code = null;
    },
    onDisabledNextButton(val) {
      this.disabledNextButton = val;
    },
    onDisableNextButtonForTimeSlots(val) {
      this.disabledNextButtonForTimeSlots = val;
    },
    setReservationToSessionStorage(model) {
      LocalStorage.set(model, 'reservation');
    },
    getReservationFromSessionStorage() {
      return LocalStorage.get('reservation');
    },
    removeReservationToSessionStorage() {
      LocalStorage.removeKey('reservation');
    },
  },

  async created() {
    await this.populateStep();
  },
};
</script>
<style lang="scss">
$circle-length: 300px;
$check-length: 35px;
@keyframes scaleAnimation {
  0% {
    opacity: 0;
    transform: scale(1.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes drawCircle {
  0% {
    stroke-dashoffset: $circle-length;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes drawCheck {
  0% {
    stroke-dashoffset: $check-length;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes drawLine {
  from {
    stroke-dashoffset: 100;
  }
  to {
    stroke-dashoffset: 0;
  }
}

#failureAnimationCircle {
  stroke-dasharray: $circle-length $circle-length;
  stroke: #f82f66;
}

#failureAnimationCheck {
  stroke-dasharray: $check-length $check-length;
  stroke: #f82f66;
}
#successAnimationCircle {
  stroke-dasharray: $circle-length $circle-length;
  stroke: #54e476;
}

#successAnimationCheck {
  stroke-dasharray: $check-length $check-length;
  stroke: #54e476;
}

.animated1 {
  top: 8px;
  left: 8px;
  position: absolute;
}

#successAnimation.animated,
#failureAnimation.animated {
  animation: 1s ease-out 0s 1 both scaleAnimation;

  #successAnimationCircle,
  #failureAnimationCircle {
    animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle;
  }

  #successAnimationCheck {
    animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck;
  }

  .failureAnimationCheckLine {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: drawLine 1s cubic-bezier(1, 0.2, 0.1, 1) forwards;
  }
}
.modal-header {
  border-bottom: none !important;
}
.model-footer {
  border-top: none !important;
}
.icon-box {
  color: #fff;
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: -60px;
  width: 95px;
  height: 95px;
  border-radius: 50%;
  z-index: 9;
  // background: #82ce34;
  // padding: 15px;
  text-align: center;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
}
.icon-box i {
  font-size: 58px;
  position: relative;
  top: 3px;
}
.icon-box.success {
  // background: #82ce34;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.icon-box.failure {
  // background: #f8d7da;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
@media only screen and (max-width: 768px) {
  .mkdf-elements-holder.mkdf-responsive-mode-768.mkdf-one-column-alignment-center
    .mkdf-eh-item
    .mkdf-eh-item-content {
    text-align: center;
    padding: 0;
  }
  .vue-form-wizard .wizard-tab-content {
    padding: 0;
  }
  .vc_column-inner {
    padding-left: 0;
    padding-right: 0;
  }
  .mkdf-elements-holder .mkdf-eh-item-content {
    padding: 0 10px;
  }
  .vue-form-wizard .navbar .navbar-nav > li > a.wizard-btn,
  .vue-form-wizard .wizard-btn {
    min-width: auto;
  }
  .vue-form-wizard .wizard-card-footer .wizard-footer-right button {
    margin-top: 0;
  }
}
.logo {
  width: 95px;
  height: 95px;
}
.wizard-card-footer {
  margin-bottom: 40px;
}
</style>
